import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';

import { colors, fonts, animate } from '../../styles/theme';

const A = styled('a')`
  color: ${colors.black};
  display: block;
  font-family: ${fonts.sans.family};
  font-weight: ${fonts.sans.weight.normal};
  padding: 4px 11px;
  text-decoration: none;
  transition: background ${animate.transition} ease;
  &:hover {
    background: ${colors.blue.secondaryLight};
    font-weight: ${fonts.sans.weight.bold};
    text-decoration: none;
  }
  &::after {
    display: block;
    content: attr(title);
    font-weight: ${fonts.sans.weight.bold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

const Li = styled('li')`
  margin: 3px 0;
  list-style: none;
  &:hover {
    cursor: pointer;
  }
`;

const DisabledLi = styled(Li)`
  &:hover {
    cursor: not-allowed;
  }
  ${A} {
    color: ${colors.grey.secondaryDark};
    &:hover {
      background: none;
      font-weight: ${fonts.sans.weight.normal};
    }
  }
`;

const DropdownMenuItem = (props) => {
  const { href, value, action, disabled } = props;

  if (disabled) {
    return (
      <DisabledLi>
        <A title={value} onClick={(evt) => evt.preventDefault()}>
          {value}
        </A>
      </DisabledLi>
    );
  }

  if (action) {
    return (
      <Li>
        <A title={value} onClick={action}>
          {value}
        </A>
      </Li>
    );
  }

  return (
    <Li>
      <A
        href={href}
        onClick={(e) => {
          e.stopPropagation();
        }}
        title={value}
      >
        {value}
      </A>
    </Li>
  );
};

DropdownMenuItem.defaultProps = {
  value: null,
  action: null,
  href: '/',
  disabled: false,
};

DropdownMenuItem.propTypes = {
  href: PropTypes.string,
  value: PropTypes.string,
  action: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DropdownMenuItem;
